<template>
  <div
    v-if="products.length > 0 && products"
    class="featured__cars mb-18 md:mb-27"
  >
    <h2 class="section_title mb-8">Anuncios similares</h2>
    <div class="wrapper-swiper-out">
      <div class="swiper-cars swiper-container grid">
        <swiper class="swiper-wrapper" :options="optionSwiper" ref="swiperTop">
          <swiper-slide v-for="(product, key) in products" :key="key">
            <thumbnail-car-component
              v-if="product"
              :product="product"
            ></thumbnail-car-component>
          </swiper-slide>
        </swiper>
      </div>
      <div
        class="swiper-button-prev swiper-button-prev-featured"
        slot="button-prev"
      >
        <span class="tx-30 tx-lightgrey-1"
          ><i class="fas fa-chevron-left"></i
        ></span>
      </div>
      <div
        class="swiper-button-next swiper-button-next-featured"
        slot="button-next"
      >
        <span class="tx-30 tx-lightgrey-1"
          ><i class="fas fa-chevron-right"></i
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import ThumbnailCarComponent from "../../layout/ThumbnailCarComponent";

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  props: {
    products: {
      type: Array,
      require: true,
    },
  },
  data: () => ({
    optionSwiper: {
      slidesPerView: "auto",
      freeMode: true,
      spaceBetween: 8,
      /* NAV */
      navigation: {
        nextEl: ".swiper-button-next-featured",
        prevEl: ".swiper-button-prev-featured",
      },
      breakpoints: {
        540: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 29,
        },
      },
    },
  }),
  components: {
    ThumbnailCarComponent,
    Swiper,
    SwiperSlide,
  },
};
</script>